import { FiltersResponse, NPSFilter } from '@/models/Filter';
import {FpAxios} from 'fp-components';
import { NPSFeedbackPublish, NPSOpinion } from '../models/NPS';
import {capitalize} from 'lodash-es';
import processProxy from '@/env/processProxy';

class NPSApi {
  private npsAxios = FpAxios.create({ baseURL: processProxy.VUE_APP_BASE_OPINIONS_URL, });

  public async getOpinions(params: Partial<NPSFilter>): Promise<FiltersResponse<NPSOpinion>> {
    const response = await this.npsAxios.post('/feedback', params);
    return response.data;
  }

  public async pocessOpinion(opinionId: number, params: NPSFeedbackPublish): Promise<boolean> {
    const response = await this.npsAxios.post(`/feedback/${opinionId}/process`, params);
    return response.data;
  }
}

export default new NPSApi();
